"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _useInterval2 = _interopRequireDefault(require("@rooks/use-interval"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Progress = _interopRequireDefault(require("./Progress"));
var _styles = require("../../shared/styles");
var _excluded = ["interval", "onComplete", "startImmediate"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var ProgressStyled = (0, _styledComponents["default"])(_Progress["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), (0, _styles.margin)('s', 'bottom'), _styles.addCssProp);
var ProgressBarTimer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var interval = _ref.interval,
    onComplete = _ref.onComplete,
    startImmediate = _ref.startImmediate,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    percent = _useState2[0],
    setPercent = _useState2[1];
  var _useState3 = (0, _react.useState)(new Date().getTime()),
    _useState4 = _slicedToArray(_useState3, 2),
    st = _useState4[0],
    setSt = _useState4[1];
  var _useInterval = (0, _useInterval2["default"])(function () {
      var diff = new Date().getTime() - st;
      var val = diff / interval * 100;
      val = val > 100 ? 100 : val;
      setPercent(val);
    }, 50, {
      startImmediate: startImmediate
    }),
    _start = _useInterval.start,
    _stop = _useInterval.stop;
  (0, _react.useEffect)(function () {
    if (_lodash["default"].isFunction(onComplete) && percent >= 100) {
      onComplete();
    }
  }, [percent]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      start: function start() {
        setSt(new Date().getTime());
        _start();
      },
      stop: function stop() {
        _stop();
      },
      reset: function reset() {
        _stop();
        setPercent(0);
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(ProgressStyled, _extends({}, props, {
    percent: percent
  }));
});
ProgressBarTimer.propTypes = {
  interval: _propTypes["default"].number,
  onComplete: _propTypes["default"].func,
  startImmediate: _propTypes["default"].bool
};
var _default = exports["default"] = ProgressBarTimer;